/* @flow */

import shortid from "shortid";
import type { DDAEntry } from "../../types";

export const createEmptyDDAEntry = (): DDAEntry => {
  return {
    id: shortid.generate(),
    businessName: "",
    address: "",
    phone: "",
    bankName: "",
    bsbNumber: "",
    accountNumber: "",
    accountHolderName: "",
    accountHolderTitle: "",
  };
};